export default __webpack_public_path__ + "static/media/(55).c9e89731.jpg";